<template>
  <div class="bdg-aside flex flex-col">
    <div class="description flex flex-row items-center text-sm w-full">
      <span class="inline uppercase text-sm mr-2">{{ title }}:</span>
      <div
        v-if="horizontal"
        class="horizontal-line inline-block flex-grow border-t border-blue"
      ></div>
      <a
        class="remove-container ml-2"
        @click="$emit('remove')"
        v-if="removable"
      >
        <i class="fal fa-trash-alt fa-fw text-red" />
      </a>
    </div>

    <p>
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: "BdgAside",
  props: {
    title: String,
    removable: Boolean,
    horizontal: { type: Boolean, default: true }
  }
};
</script>

<style lang="scss" scoped>
:not(.flex-row):not(.flex) {
  & > .bdg-input {
    & + .bdg-aside {
      @apply mt-4;
    }
  }
}
</style>
